import { useMemo } from 'react';
import { HttpClient } from '@wix/http-client';
export function useHttpClient() {
    const httpClient = useMemo(() => new HttpClient(), []);
    return httpClient;
}
//# sourceMappingURL=use-http-client.js.map